﻿$.fn.dxCtrlCompteEmailTestDelivrabilite = function custom_dxCtrlCompteEmailTestDelivrabilite(option) {
    if (option == "instance") {
        return this.instance;
    }
    else {
        this.addClass("dx-dxctrlcompteemailtestdelivrabilite dx-ctrl");
        this.createInstance(new cdxCtrlCompteEmailTestDelivrabilite(this, option));
    }
    return this;
}

window.cdxCtrlCompteEmailTestDelivrabilite = function (container, option) {
    var Me = this;

    this.option = function (name, value) {
        if (typeof value == 'undefined') {
            return option[name];
        }
        else {
            option[name] = value;
        }
    }

    if (typeof option.allowSave == 'undefined') option.allowSave = true

    var dxEmailFrom = null
    var dxSmtpServer = null
    var dxSmtpLogin = null
    var dxSmtpPwd = null
    var dxSmtpPort = null
    var dxSmtpSsl = null
    var dxEmailSendRapport = null
    function mConstruit() {
        container.empty();

        var $DivSaisie = $("<div style='margin:10px;padding:20px;background-color:" + theme.backgroundColorTitle + ";'/>").appendTo(container)
        dxEmailFrom = $("<div style='margin:5px 0;'/>").appendTo($DivSaisie).dxCtrlTextEmail({
            labelMode: 'floating',
            label: "Adresse mail expéditeur",
            name: "hkjgkhkj",
            value: "",
            placeholder: "Saisissez l'expéditeur de l'email de test (from)...",
            maxLength: 500,
            onValueChanged: function (e) {
            }
        }).dxCtrlTextEmail("instance");

        dxSmtpLogin = $("<div style='margin:5px 0;'/>").appendTo($DivSaisie).dxCtrlTextBox({
            label: "Login pour se connecter",
            labelMode: 'floating',
            placeholder: "Le login correspond, en général, à votre adresse email...",
            value: "",
            onValueChanged: function (e) {
            }
        }).dxCtrlTextBox("instance")

        dxSmtpPwd = $("<div style='margin:5px 0;'/>").appendTo($DivSaisie).dxCtrlTextBox({
            label: "Mot de passe",
            labelMode: 'floating',
            placeholder: "...",
            value: "",
            onValueChanged: function (e) {
            },
            buttons: [{
                focusStateEnabled: false,
                name: 'showpwd',
                location: 'after',
                options: {
                    icon: 'eyeopen',
                    hint: "Révéler/cacher le texte",
                    focusStateEnabled: false,
                    stylingMode: 'text',
                    onClick() {
                        if (dxSmtpPwd.element().find("input").hasClass("txtPassword")) {
                            dxSmtpPwd.element().find("input").removeClass("txtPassword")
                        } else {
                            dxSmtpPwd.element().find("input").addClass("txtPassword")
                        }
                    },
                },
            }],
            onContentReady: function (e) {
                e.component.element().find("input").addClass("txtPassword")
            }
        }).dxCtrlTextBox("instance")

        dxSmtpServer = $("<div style='margin:5px 0;'/>").appendTo($DivSaisie).dxCtrlTextBox({
            label: "Adresse du serveur",
            labelMode: 'floating',
            placeholder: "...",
            value: "",
            onValueChanged: function (e) {

            }
        }).dxCtrlTextBox("instance")

        var $Table = $("<table style='width:100%;margin:5px 0;'/>").appendTo($DivSaisie)
        var $Tr = $("<tr/>").appendTo($Table)
        var $Td = $("<td style='width:100%;'></td>").appendTo($Tr)
        dxSmtpPort = $("<div/>").appendTo($Td).dxCtrlNumberBox({
            label: "Port du serveur",
            labelMode: 'floating',
            placeholder: "...",
            value: 465,
            width: "100%",
            onValueChanged: function (e) {
            }
        }).dxCtrlNumberBox("instance")

        var $Td = $("<td style='width:1px;white-space:nowrap;padding-left:10px;'>SSL/TLS:</td>").appendTo($Tr)
        var $Td = $("<td style='width:1px;padding-left:10px;vertical-align:middle;'/>").appendTo($Tr)
        dxSmtpSsl = $("<div/>").appendTo($Td).dxCtrlSwitch({
            width: 50,
            value: true,
            focusStateEnabled: false,
            onValueChanged: function (e) {
            }
        }).dxCtrlSwitch("instance")

        dxEmailSendRapport = $("<div/>").appendTo($DivSaisie).dxCtrlTextEmail({
            labelMode: 'floating',
            label: "Email où envoyer le récapitulatif du test (facultatif)",
            name: "hkjgkhkj",
            value: "",
            maxLength: 500,
            onValueChanged: function (e) {
            }
        }).dxCtrlTextEmail("instance");

        $("<div/>").appendTo(container).dxCtrlButton({
            width: "100%",
            html: "Tester la délivrabilité" + ((typeof option.ssTitle != 'undefined') ? "<br/>" + option.ssTitle : ""),
            onClick: function (e) {
                var ok = true
                dxEmailFrom.element().find("input").css("background-color", "")
                if (dxEmailFrom.option("value") == null || dxEmailFrom.option("value").length == 0 || dxEmailFrom.hasErreur) {
                    dxEmailFrom.element().find("input").css("background-color", "#ffcccc")
                    ok = false
                }
                dxSmtpLogin.element().find("input").css("background-color", "")
                if (dxSmtpLogin.option("value") == null || dxSmtpLogin.option("value").length == 0) {
                    dxSmtpLogin.element().find("input").css("background-color", "#ffcccc")
                    ok = false
                }
                dxSmtpPwd.element().find("input").css("background-color", "")
                if (dxSmtpPwd.option("value") == null || dxSmtpPwd.option("value").length == 0) {
                    dxSmtpPwd.element().find("input").css("background-color", "#ffcccc")
                    ok = false
                }
                dxSmtpServer.element().find("input").css("background-color", "")
                if (dxSmtpServer.option("value") == null || dxSmtpServer.option("value").length == 0) {
                    dxSmtpServer.element().find("input").css("background-color", "#ffcccc")
                    ok = false
                }
                dxSmtpPort.element().find("input").css("background-color", "")
                if (dxSmtpPort.option("value") == null || dxSmtpPort.option("value").length == 0) {
                    dxSmtpPort.element().find("input").css("background-color", "#ffcccc")
                    ok = false
                }
                if (ok) { mShowTest(0) }
                else { mNotify("Veuillez remplir les champs signalé en rouge", "error", 6000) }
            }
        })
    }

    var popupContentElement = null
    var jauge = null
    var popup = null
    function mShowTest(idTypeSmtp) {
        popup = $("<div/>").appendTo("body").dxCtrlPopupBase({
            position: {
                my: "right top",
                at: "right top",
                of: "body"
            },
            width: 600,
            height: "100%",
            showTitle: false,
            showMaximize: false,
            contentTemplate: function (contentElement) {
                contentElement.css("position", "relative")
                popupContentElement = contentElement
            },
            onShown: function (e) {
                if (typeof option.idTypeSmtp != 'undefined' && option.idTypeSmtp == 0) {
                    //Si c'est un test de smtp, on ne peut pas fermer la fenetre
                } else {
                    dxBtClose = $("<div style='position:absolute;z-index:101;top:2px;right:5px'/>").appendTo(popupContentElement).dxCtrlButton({
                        icon: 'fas fa-times',
                        width: HeightButton,
                        height: HeightButton,
                        onClick: function (e) {
                            popup.hide()
                        }
                    }).dxCtrlButton("instance");
                }

                jauge = $("<div/>").appendTo(popupContentElement).dxCtrlJauge({}).dxCtrlJauge("instance")
                jauge.option("onCancel", function () {
                    popup.hide()
                })
                jauge.mShow()
                jauge.option("message", "Génération du test de délivrabilité")
                option.bddCtrl.mAjaxCall({
                    command: "testdelivrabilitesmtp",
                    smtp_from: dxEmailFrom.option("value"),
                    smtp_serveur: dxSmtpServer.option("value"),
                    smtp_login: dxSmtpLogin.option("value"),
                    smtp_pwd: dxSmtpPwd.option("value"),
                    smtp_port: dxSmtpPort.option("value"),
                    smtp_ssl: ((dxSmtpSsl.option("value")) ? "1" : "0"),
                    email_send_rapport: dxEmailSendRapport.option("value")
                }, function (data) {
                    if (typeof data.result != 'undefined' && data.result.length > 0) {
                        mConstruitTest(JSON.parse(data.result), dxEmailSendRapport.option("value"))
                    } else {
                        mNotify("Impossible d'effectuer le test.<br/>Veuillez vérifier votre saisie.", "error", 15000)
                        popup.hide()
                    }
                })
            }
        }).dxCtrlPopupBase("instance")
        popup.show()
    }

    function mConstruitTest(dataDelivrabilite, adresseEmailSendResult) {
        var $DivScroll = $("<div style='margin-top:25px;height:calc(100% - 25px)'/>").appendTo(popupContentElement);
        var dxScrollView = $DivScroll.dxScrollView({}).dxScrollView("instance")

        var HtmlEmail = "";
        HtmlEmail = "<div>Test de délivrabilité du " + dataDelivrabilite.messageInfo.dateReceived + "</div>"
        HtmlEmail += "<div>Test de délivrabilité du serveur SMTP <u>" + dxSmtpServer.option("value") + "</u>.</div>"

        $(HtmlEmail).appendTo(dxScrollView.content());
        if (typeof adresseEmailSendResult != "undefined" && adresseEmailSendResult != null && adresseEmailSendResult.length > 0) $("<div>Une copie de ce rapport vous a été envoyé par email</div>").appendTo(dxScrollView.content());
        $("<hr/>").appendTo(dxScrollView.content());

        var html = "<div>" + dataDelivrabilite.messageInfo.subject + "</div>"
        $(html).appendTo(dxScrollView.content()); HtmlEmail += html;

        html = "<div>" + dataDelivrabilite.messageInfo.fromAddressDisplayed + "</div>"
        $(html).appendTo(dxScrollView.content()); HtmlEmail += html;
        html = "<div>" + dataDelivrabilite.messageInfo.bounceAddressDisplayed + "</div>"
        $(html).appendTo(dxScrollView.content()); HtmlEmail += html;
        html = "<div>" + dataDelivrabilite.messageInfo.replytoDisplayed + "</div>"
        $(html).appendTo(dxScrollView.content()); HtmlEmail += html;

        $DivTitre = $("<div style='text-align:center;padding-bottom:10px'/>").appendTo(dxScrollView.content());
        HtmlEmail += "<div style='text-align:center;padding-bottom:10px'>"

        html = "<div style='display:inline;width:1px;font-size:30px;white-space:nowrap;'>Votre score</div>"
        $(html).appendTo($DivTitre); HtmlEmail += html;

        $("<br/>").appendTo($DivTitre); HtmlEmail += "<br/>";
        $("<br/>").appendTo($DivTitre); HtmlEmail += "<br/>";
        dataDelivrabilite.mark = dataDelivrabilite.mark - dataDelivrabilite.spamAssassin.mark;
        var score = ((dataDelivrabilite.mark == 0) ? 10 : 10 + dataDelivrabilite.mark).toFixed(1)
        html = "<div style='padding:10px;display:inline;min-width:60px;width:60px;height:60px;font-weight:bold;text-align:right;border-radius:10px;font-size:30px;background-color:" + ((score >= 9) ? "green" : ((score >= 5) ? "orange" : "red")) + "'>" + score + "</div>"
        $(html).appendTo($DivTitre); HtmlEmail += html;

        $("<br/>").appendTo($DivTitre); HtmlEmail += "<br/>";

        html = "<div style='font-size:17px;padding-top:7px'></div>"
        $(html).appendTo($DivTitre); HtmlEmail += html;
        //if (10 + data.mark <= 6) {
        //    $("<div style='padding-top:7px'>Pour augmenter votre taux de délivrabilité, vous pouvez faire les manipulations recommandées pour chaque point détaillé ci-dessous.<br/>Nous pouvons aussi mettre à votre disposition une adresse email du type <b><u>" + donnees.nomCompte + ((donnees.nomLogiciel.toLowerCase() == "mascaron") ? "@masca.fr" : "@mangonaute.com") + "</u></b> qui sera configurée correctement pour l'envoi de mail via " + donnees.nomLogiciel + " <a href='javascript:void(0)' onclick='header.mShowAide();'>Pour plus d'information, contacter l'assistance</a></div>").appendTo($DivTitre);
        //    HtmlEmail += "<div style='padding-top:7px'>Pour augmenter votre taux de délivrabilité, vous pouvez faire les manipulations recommandées pour chaque point détaillé ci-dessous.<br/>Nous pouvons aussi mettre à votre disposition une adresse email du type <b><u>" + donnees.nomCompte + ((donnees.nomLogiciel.toLowerCase() == "mascaron") ? "@masca.fr" : "@mangonaute.com") + "</u></b> qui sera configurée correctement pour l'envoi de mail via " + donnees.nomLogiciel + " <a href='javascript:void(0)' onclick='window.parent.header.mShowAide();'>Pour plus d'information, contacter l'assistance</a></div>";
        //}
        HtmlEmail += "</div>"
        HtmlEmail += "<hr/>"

        var dataAcc = [];

        dataDelivrabilite.body.visible = false
        dataAcc.push(dataDelivrabilite.body);
        //HtmlEmail += mConstruitTitle($("<div/>"), dataDelivrabilite.body)
        //HtmlEmail += mConstruitBodyDetail($("<div/>"), dataDelivrabilite.body);
        //HtmlEmail += "<hr/>"
        dataDelivrabilite.links.visible = false
        dataAcc.push(dataDelivrabilite.links);
        //HtmlEmail += mConstruitTitle($("<div/>"), dataDelivrabilite.links)
        //HtmlEmail += mConstruitLinksDetail($("<div/>"), dataDelivrabilite.links);
        //HtmlEmail += "<hr/>"

        //if (ctrlCommunication) {
        //    dataAcc.push(dataDelivrabilite.spamAssassin);
        //    HtmlEmail += Me.mConstruitTitle($("<div/>"), dataDelivrabilite.spamAssassin)
        //    HtmlEmail += Me.mConstruitSpamAssassinDetail($("<div/>"), dataDelivrabilite.spamAssassin);
        //    HtmlEmail += "<hr/>"
        //}
        dataAcc.push(dataDelivrabilite.signature);
        HtmlEmail += mConstruitTitle($("<div/>"), dataDelivrabilite.signature)
        HtmlEmail += mConstruitSignatureDetail($("<div/>"), dataDelivrabilite.signature);

        dataAcc.push(dataDelivrabilite.blacklists);

        //envoi du mail
        //if (typeof adresseEmailSendResult != "undefined" && adresseEmailSendResult != null && adresseEmailSendResult.length > 0) option.bddCtrl.mAjaxCall({ command: "envoimailresulttestdelivrabilite", adresse_email: adresseEmailSendResult, html: HtmlEmail })
        //donnees.mAjaxCall("/n/webcontrol/datahandler.ashx", {
        //    command: "sendemail",
        //    objet: "Test de délivrabilité du " + dataDelivrabilite.messageInfo.dateReceived,
        //    html: HtmlEmail,
        //    dest: dataDelivrabilite.messageInfo.bounceAddress,
        //    url: url
        //}, function (data) {
        //}, function () {
        //}, function () {
        //});

        $("<div/>").appendTo(dxScrollView.content()).dxAccordion({
            dataSource: dataAcc,
            selectedIndex: 2,
            itemTitleTemplate: function (itemData, itemIndex, itemElement) {
                mConstruitTitle(itemElement, itemData)
            },
            itemTemplate: function (itemData, itemIndex, itemElement) {
                //switch (itemIndex) {
                //    case 0:
                //        mConstruitSignatureDetail(itemElement, itemData);
                //}
                switch (itemIndex) {
                    case 0:
                        mConstruitBodyDetail(itemElement, itemData);
                        break;
                    case 1:
                        mConstruitLinksDetail(itemElement, itemData);
                        break;
                    case 2:
                        //if (ctrlCommunication) {
                        //    mConstruitSpamAssassinDetail(itemElement, itemData);
                        //}
                        //else {
                        mConstruitSignatureDetail(itemElement, itemData);
                        //}
                        break;
                    //case 3:
                    //    mConstruitSignatureDetail(itemElement, itemData);
                    //    break;
                    case 3:
                        mConstruitBlackList(itemElement, itemData.blacklists);
                        break;
                }
            }
        });
        jauge.mHide(500);
    }

    var thumbsDownData64 = "data:image/png;base64,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"
    var thumbsUpData64 = "data:image/png;base64,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"

    function mConstruitTitle(itemElement, itemData) {
        var $Table = $("<table style='width:95%'/>").appendTo(itemElement);
        var $Tr = $("<tr/>").appendTo($Table);
        var $Td = $("<td style='min-width:40px;height:30px;font-weight:bold;text-align:center;border-radius:10px;background-color:" + ((itemData.mark == 0) ? "green" : "red") + "'>" + ((itemData.mark == 0) ? "<img src='" + thumbsUpData64 + "' style='width:30px;'/>" : itemData.mark) + "</td>").appendTo($Tr);
        var $Td = $("<td style='width:100%;padding-left:5px;'>" + itemData.title + "</td>").appendTo($Tr);
        return $Table[0].outerHTML;
    }
    function mConstruitBodyDetail(itemElement, itemData) {
        itemElement.css("padding-left", "50px");
        $("<div style='font-weight:bold;font-size:14px;'>" + itemData.description + "</div>").appendTo(itemElement);
        $(itemData.messages).appendTo(itemElement);

        $.each(itemData.subtests, function (key, subt) {
            if (key != "textToHtmlRatio") {
                $("<hr/>").appendTo(itemElement);
                var $Table = $("<table style='width:100%;table-layout: fixed;'/>").appendTo(itemElement);
                var $Tr = $("<tr/>").appendTo($Table);
                var $Td = $("<td style='min-width:40px;max-width:40px;width:40px;height:30px;font-weight:bold;border-radius:10px;text-align:center;background-color:" + ((subt.mark == 0) ? "green" : "red") + "'>" + ((subt.mark == 0) ? "<img src='" + thumbsUpData64 + "' style='width:30px;'/>" : subt.mark) + "</td>").appendTo($Tr);
                var $Td = $("<td style='cursor:pointer;width:100%;padding-left:5px;' class='tdclick'><b>" + subt.title + "</b></td>").appendTo($Tr);
                var $DivDescription = $("<div style='display:none;' class='divdescription'><i>" + subt.description + "</i></div>").appendTo($Td);
                $Td.on("click", function () {
                    if ($DivDescription.is(":visible")) { $DivDescription.hide(200); }
                    else { $DivDescription.show(200); }
                });
                var $Td = $("<td style='width:40px;padding-left:5px;vertical-align:top;' class='cmd'></td>").appendTo($Tr);
                $("<div/>").appendTo($Td).dxButton({
                    icon: 'chevrondown',
                    onClick: function (e) {
                        if (e.component.option("icon") == "chevrondown") {
                            $DivDescription.show(200);
                            e.component.option("icon", "chevronup")
                        } else {
                            $DivDescription.hide(200);
                            e.component.option("icon", "chevrondown")
                        }
                    }
                });
            }
        });

        var newItem = itemElement.clone()
        newItem.find(".divdescription").css("display", "");
        newItem.find(".tdclick").attr("click", "");
        newItem.find(".cmd").remove();

        return newItem[0].outerHTML;
    }
    function mConstruitLinksDetail(itemElement, itemData) {
        itemElement.css("padding-left", "50px");
        $("<div style='font-weight:bold;font-size:14px;'>" + itemData.description + "</div>").appendTo(itemElement);
        $(itemData.messages).appendTo(itemElement);
        return itemElement[0].outerHTML;
    }
    function mConstruitSpamAssassinDetail(itemElement, itemData) {
        itemElement.css("padding-left", "50px");
        $("<div style='font-weight:bold;font-size:14px;'>" + itemData.description + "</div>").appendTo(itemElement);
        $(itemData.messages).appendTo(itemElement);

        $("<hr/>").appendTo(itemElement);
        var $Table = $("<table style='width:100%;'/>").appendTo(itemElement);
        $.each(itemData.rules, function (key, subt) {
            var $Tr = $("<tr/>").appendTo($Table);
            var $Td = $("<td style='min-width:40px;max-width:40px;width:40px;height:30px;font-weight:bold;border-radius:10px;text-align:center;background-color:" + ((subt.score == 0) ? "green" : "red") + "'>" + ((subt.score == 0) ? "<img src='" + thumbsUpData64 + "' style='width:30px;'/>" : subt.score) + "</td>").appendTo($Tr);
            var $Td = $("<td style='width:1px;padding-left:5px;padding-right:5px;'><a href='http://wiki.apache.org/spamassassin/Rules/" + key + "' target='_blank'><b>" + key + "</b></a></td>").appendTo($Tr);
            var $Td = $("<td style='width:100%;padding-left:5px;'><i>" + subt.solution + "</i></td>").appendTo($Tr);
        });
        return itemElement[0].outerHTML;
    }
    function mConstruitSignatureDetail(itemElement, itemData) {
        itemElement.css("padding-left", "50px");
        $("<div style='font-weight:bold;font-size:14px;'>" + itemData.description + "</div>").appendTo(itemElement);
        $(itemData.messages).appendTo(itemElement);

        $.each(itemData.subtests, function (key, subt) {
            $("<hr/>").appendTo(itemElement);
            var $Table = $("<table style='width:100%;table-layout: fixed;'/>").appendTo(itemElement);
            var $Tr = $("<tr/>").appendTo($Table);
            var $Td = $("<td style='min-width:40px;max-width:40px;width:40px;height:30px;font-weight:bold;border-radius:10px;text-align:center;background-color:" + ((subt.mark == 0) ? "green" : "red") + "'>" + ((subt.mark == 0) ? "<img src='" + thumbsUpData64 + "' style='width:30px;'/>" : subt.mark) + "</td>").appendTo($Tr);
            var $Td = $("<td style='cursor:pointer;width:100%;padding-left:5px;' class='tdclick'><b>" + subt.title + "</b></td>").appendTo($Tr);
            var $DivDescription = $("<div style='display:none;font-size:13px' class='divdescription'><i>" + subt.description + "</i><br/><div style='font-size:11px;white-space:normal;overflow-x:auto;'>" + subt.messages.remplacerTout("<pre>", "<pre style='white-space:normal'>").remplacerTout("Besoin d'aide?", "").remplacerTout("Voir les manuels", "").remplacerTout(" pour chaque hôte.", "") + "</div></div>").appendTo($Td);
            //if (subt.mark != 0) {
            //    switch (key) {
            //        case "dkim":
            //            $("<br/>").appendTo($DivDescription)
            //            $("<div><a href='javascript:void(0)' onclick='header.mShowAide();'>Vous pouvez contacter l'assistance de " + donnees.nomLogiciel + " pour créer un enregistrement DKIM sur votre domaine</a></div>").appendTo($DivDescription)
            //            break;
            //        case "spf":
            //        case "senderId":
            //            $("<br/>").appendTo($DivDescription)
            //            $("<div style='padding:8px;margin:8px;border:1px solid gainsboro;border-radius:5px;'>Pour corriger le problème, vous pouvez créer un enregistrement SPF sur le DNS de votre nom de domaine avec:<br/><b>v=spf1 ip4:212.83.133.91 ip4:212.83.132.218 ip4:212.83.132.34 ip4:212.83.133.119 ip4:212.83.133.156 ip4:212.83.133.158 ip4:163.172.211.250 ip4:163.172.211.244 ip4:163.172.211.246 ip4:163.172.211.248 mx ~all</b><br/><span style='color:orange'>ATTENTION, si vous avez déjà un enregistrement SPF que vous voulez conserver (par exemple, l'enregistrement SPF de votre hébergeur pour utiliser le propre SMTP de votre adresse email), il faut fusionnez ce SPF avec celui qui vous est proposé ci-dessus. Contacter l'hébergeur de votre nom de domaine si vous voulez être sur de ne pas faire une erreur.</span></div>").appendTo($DivDescription)
            //            $("<div><a href='javascript:void(0)' onclick='header.mShowAide();'>Pour plus d'information, contacter l'assistance</a></div>").appendTo($DivDescription)
            //            break;
            //    }
            //}
            $Td.on("click", function () {
                if ($DivDescription.is(":visible")) { $DivDescription.hide(200); }
                else { $DivDescription.show(200); }
            });
            var $Td = $("<td style='width:40px;padding-left:5px;vertical-align:top;' class='cmd'></td>").appendTo($Tr);
            $("<div/>").appendTo($Td).dxButton({
                icon: 'chevrondown',
                onClick: function (e) {
                    if (e.component.option("icon") == "chevrondown") {
                        $DivDescription.show(200);
                        e.component.option("icon", "chevronup")
                    } else {
                        $DivDescription.hide(200);
                        e.component.option("icon", "chevrondown")
                    }
                }
            });
        });

        var newItem = itemElement.clone()
        newItem.find(".divdescription").css("display", "");
        newItem.find(".tdclick").attr("click", "");
        newItem.find(".cmd").remove();

        return newItem[0].outerHTML;
    }

    function mConstruitBlackList(itemElement, itemData) {
        itemElement.css("padding-left", "50px");
        $("<div style='font-weight:bold;font-size:14px;'>" + itemData.description + "</div>").appendTo(itemElement);
        $(itemData.messages).appendTo(itemElement);
        $.each(itemData, function (key, subt) {
            $("<hr/>").appendTo(itemElement);
            var $Table = $("<table style='width:100%;table-layout: fixed;'/>").appendTo(itemElement);
            var $Tr = $("<tr/>").appendTo($Table);
            var $Td = $("<td style='min-width:40px;max-width:40px;width:40px;height:30px;font-weight:bold;border-radius:10px;text-align:center;background-color:" + ((subt.mark == 0) ? "green" : "red") + "'>" + ((subt.mark == 0) ? "<img src='" + thumbsUpData64 + "' style='width:30px;'/>" : subt.mark) + "</td>").appendTo($Tr);
            var $Td = $("<td style='cursor:pointer;width:100%;padding-left:5px;' class='tdclick'><b>" + subt.dns + "</b></td>").appendTo($Tr);
            var $DivDescription = $("<div style='display:none;' class='divdescription'></div>").appendTo($Td);
            if (typeof subt.description != 'undefined') $("<div><i>" + subt.description + "</i></div>").appendTo($DivDescription);
            if (typeof subt.removal != 'undefined') $("<div>" + subt.removal + "</div>").appendTo($DivDescription);
            $("<div><a href='" + subt.url + "' target='_blank'>" + subt.url + "</a></div>").appendTo($DivDescription);
            $Td.on("click", function () {
                if ($DivDescription.is(":visible")) { $DivDescription.hide(200); }
                else { $DivDescription.show(200); }
            });
            var $Td = $("<td style='width:40px;padding-left:5px;vertical-align:top;' class='cmd'></td>").appendTo($Tr);
            $("<div/>").appendTo($Td).dxButton({
                icon: 'chevrondown',
                onClick: function (e) {
                    if (e.component.option("icon") == "chevrondown") {
                        $DivDescription.show(200);
                        e.component.option("icon", "chevronup")
                    } else {
                        $DivDescription.hide(200);
                        e.component.option("icon", "chevrondown")
                    }
                }
            });
        })
    }

    this.element = function () { return container }

    mConstruit();
}